import React from "react"
import { FlexContainer } from "@carrotfertility/carotene"
import { Pagination } from "@carrotfertility/carotene-core"

type PaginationBarProps = {
  count: number
  page: number
  onChange: (event: React.ChangeEvent<unknown>, page: number) => void
}

export function PaginationBar({ count, page, onChange }: PaginationBarProps): JSX.Element {
  return (
    <FlexContainer justifyContent="center">
      <Pagination
        count={count}
        page={page}
        onChange={onChange}
        sx={{
          "li:before": {
            display: "none"
          },
          ".MuiPaginationItem-root": {
            color: "rgba(0, 0, 0, 0.8)",
            ":hover": {
              backgroundColor: "#E48400",
              color: "white"
            },
            ":focus-visible": {
              backgroundColor: "#E48400",
              color: "white"
            },
            ".MuiStepButton-touchRipple": {
              backgroundColor: "#FCF3E5"
            },
            "&.Mui-selected": {
              backgroundColor: "#FAE6CC",
              ":hover": {
                backgroundColor: "#E48400",
                color: "white"
              },
              ":focus-visible": {
                backgroundColor: "#E48400",
                color: "white"
              }
            }
          },
          ".MuiPaginationItem-ellipsis": {
            ":hover": {
              background: "white",
              color: "rgba(0, 0, 0, 0.8)"
            }
          }
        }}
      />
    </FlexContainer>
  )
}
